var map = {
	"./icon-admin-difficulty-0.svg": 1354,
	"./icon-admin-difficulty-1.svg": 1355,
	"./icon-admin-difficulty-2.svg": 1356,
	"./icon-admin-info.svg": 1357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3475;